import { Box, Map as MapIcon, RotateCw, Satellite, Undo2, Building2 } from "lucide-react";

const Btn = ({ active, onClick, children, testId, label }) => (
  <button
    type="button"
    onClick={onClick}
    data-testid={testId}
    aria-label={label}
    aria-pressed={active}
    className={`flex h-9 items-center gap-1.5 px-3 text-[12px] font-medium transition-colors ${
      active ? "bg-ink text-white" : "bg-white/95 text-ink hover:bg-white"
    }`}
  >
    {children}
  </button>
);

const MODES = [
  { id: "satellite", label: "Satellite", Icon: Satellite },
  { id: "model", label: "3D Model", Icon: Building2 },
  { id: "streets", label: "Map", Icon: MapIcon },
];

export const MapControls = ({ className = "top-3", mode, onMode, tilted, onTilt, orbit, canOrbit, onOrbit, onReset }) => (
  <div className={`pointer-events-none absolute right-3 z-10 flex flex-col items-end gap-2 ${className}`}>
    <div className="pointer-events-auto flex overflow-hidden rounded-full shadow-[0_8px_24px_-8px_rgba(0,0,0,0.5)] backdrop-blur">
      {MODES.map(({ id, label, Icon }) => (
        <Btn key={id} active={mode === id} onClick={() => onMode(id)} testId={`map-mode-${id}`} label={label}>
          <Icon className="h-3.5 w-3.5" /> <span className="hidden sm:inline">{label}</span>
        </Btn>
      ))}
    </div>
    <div className="pointer-events-auto flex overflow-hidden rounded-full shadow-[0_8px_24px_-8px_rgba(0,0,0,0.5)] backdrop-blur">
      <Btn active={tilted} onClick={onTilt} testId="map-toggle-3d" label="Toggle 3D tilt">
        <Box className="h-3.5 w-3.5" /> {tilted ? "3D" : "2D"}
      </Btn>
      {canOrbit && (
        <Btn active={orbit} onClick={onOrbit} testId="map-toggle-orbit" label="Orbit around">
          <RotateCw className={`h-3.5 w-3.5 ${orbit ? "animate-spin [animation-duration:3s]" : ""}`} /> Orbit
        </Btn>
      )}
      <Btn onClick={onReset} testId="map-reset-view" label="Reset view">
        <Undo2 className="h-3.5 w-3.5" />
      </Btn>
    </div>
  </div>
);
